import React from "react";
import { Link } from "react-router-dom";
import Moment from "react-moment";

import "moment/locale/es";
import { jsUcfirst } from "../utils/helpers.js";
import Mejor from "./Mejor";
import MejorComp from "./MejorComp";
import Titulin from "./Titulin";
import SearchGen from "./SearchGen";

class Resumen extends React.Component {
	constructor(props) {
		super();
		this.state = {
			fase: "semis_"
		};
	}
	// END CONSTRUCTOR

	render() {
		const todas = Object.keys(this.props.agrupaciones);

		const cuartetos = Object.keys(this.props.agrupaciones).filter(key =>
			this.props.agrupaciones[key].cat.includes("cuarteto")
		);
		const coros = Object.keys(this.props.agrupaciones).filter(key =>
			this.props.agrupaciones[key].cat.includes("coro")
		);
		const chirigotas = Object.keys(this.props.agrupaciones).filter(key =>
			this.props.agrupaciones[key].cat.includes("chirigota")
		);
		const comparsas = Object.keys(this.props.agrupaciones).filter(key =>
			this.props.agrupaciones[key].cat.includes("comparsa")
		);

		// DEVUELVE IDE DE LOS EMPATES
		const ordenar = (grupo, cat) => {
			const temp = grupo.sort(
				(a, b) =>
					this.props.agrupaciones[a][cat] > this.props.agrupaciones[b][cat]
						? -1
						: 1
			);
			const max = temp[0];
			return temp.filter(
				x =>
					this.props.agrupaciones[x][cat] ===
					this.props.agrupaciones[[temp[0]]][cat]
			);
		};

		const ordenarEst = (grupo, cat) => {
			const temp = grupo.sort(
				(a, b) =>
					this.props.agrupaciones[a][cat] > this.props.agrupaciones[b][cat]
						? -1
						: 1
			);
			const max = temp[0];
			return temp.filter(
				x =>
					this.props.agrupaciones[x][cat] ===
					this.props.agrupaciones[[temp[0]]][cat]
			);
		};

		const mejorCuarteto = ordenar(cuartetos, `${this.state.fase}tot`);
		const mejorCoro = ordenar(coros, `${this.state.fase}tot`);
		const mejorComparsa = ordenar(comparsas, `${this.state.fase}tot`);
		const mejorChirigota = ordenar(chirigotas, `${this.state.fase}tot`);
		const mejorTipo = ordenar(todas, `${this.state.fase}tip`);
		const mejorEstribillo = ordenarEst(todas, `${this.state.fase}est`);
		const mejorPresentacion = ordenar(todas, `${this.state.fase}pre`);

		return (
			<div>
				<div className="tramaBusquedaGen">
					<div className="container" id="busquedaGen">
						<SearchGen history={this.props.history} />
					</div>
				</div>
				<div className="container resumen">
					<Titulin titulo="Mejores agrupaciones" />
					{mejorCoro !== null && mejorCoro !== undefined ? (
						<Mejor
							ides={mejorCoro}
							categoria="coro"
							agrupaciones={this.props.agrupaciones}
							fase={this.state.fase}
						/>
					) : (
						""
					)}
					{mejorChirigota !== null && mejorChirigota !== undefined ? (
						<Mejor
							ides={mejorChirigota}
							categoria="chirigota"
							agrupaciones={this.props.agrupaciones}
							fase={this.state.fase}
						/>
					) : (
						""
					)}
					{mejorComparsa !== null && mejorComparsa !== undefined ? (
						<Mejor
							ides={mejorComparsa}
							categoria="comparsa"
							agrupaciones={this.props.agrupaciones}
							fase={this.state.fase}
						/>
					) : (
						""
					)}
					{mejorCuarteto !== null && mejorCuarteto !== undefined ? (
						<Mejor
							ides={mejorCuarteto}
							categoria="cuarteto"
							agrupaciones={this.props.agrupaciones}
							fase={this.state.fase}
						/>
					) : (
						""
					)}

					<Titulin titulo="Mejores composiciones" />
					<div className="mejoresComposiciones">
						{mejorTipo !== null && mejorTipo !== undefined ? (
							<MejorComp
								ides={mejorTipo}
								categoria="tipo"
								mod="tip"
								agrupaciones={this.props.agrupaciones}
								fase={this.state.fase}
							/>
						) : (
							""
						)}
						{mejorEstribillo !== null && mejorEstribillo !== undefined ? (
							<MejorComp
								ides={mejorEstribillo}
								categoria="estribillo"
								mod="est"
								agrupaciones={this.props.agrupaciones}
								fase={this.state.fase}
							/>
						) : (
							""
						)}
						{mejorPresentacion !== null && mejorPresentacion !== undefined ? (
							<MejorComp
								ides={mejorPresentacion}
								categoria="presentación"
								mod="pre"
								agrupaciones={this.props.agrupaciones}
								fase={this.state.fase}
							/>
						) : (
							""
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default Resumen;



// WEBPACK FOOTER //
// ./src/components/Resumen.js